// extracted by mini-css-extract-plugin
export default {"messageContainer":"nt1ws","icon":"_4y3we","text":"Ehsuv"};